import { BrandMark } from "../components/BrandMark";
import { Link } from "../router";

export function Landing() {
  return (
    <div className="landing">
      <nav className="landing-nav">
        <div className="brand">
          <BrandMark />
          <span>Andersen</span>
        </div>
        <div className="landing-nav-links">
          <Link className="btn btn-ghost" to="/login">
            Sign in
          </Link>
        </div>
      </nav>

      <section className="hero">
        <div>
          <span className="eyebrow">A Quantfolio demo environment</span>
          <h1 className="hero-title">
            Wealth, the <em>Nordic</em> way.
          </h1>
          <p className="hero-lede">
            Andersen Wealth Management is a sandbox showcasing what the Quantfolio
            Platform can do — CRM, portfolio, and order management, all wired to
            an AI agent through purpose-built MCP tools.
          </p>
          <div className="hero-meta">
            <div className="hero-meta-item">
              <span className="label">Investors</span>
              <span className="value">Curated</span>
            </div>
            <div className="hero-meta-item">
              <span className="label">Accounts</span>
              <span className="value">Aggregated</span>
            </div>
            <div className="hero-meta-item">
              <span className="label">Orders</span>
              <span className="value">Tracked</span>
            </div>
            <div className="hero-meta-item">
              <span className="label">Agent</span>
              <span className="value">MCP-ready</span>
            </div>
          </div>
        </div>

        <div className="hero-art" aria-hidden>
          <svg viewBox="0 0 400 480" preserveAspectRatio="none">
            <defs>
              <linearGradient id="line-gradient" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="#E8B65A" stopOpacity="0.0" />
                <stop offset="60%" stopColor="#E8B65A" stopOpacity="0.55" />
                <stop offset="100%" stopColor="#E8B65A" stopOpacity="0.9" />
              </linearGradient>
            </defs>
            {/* Topographic-style contour lines, evoking a Nordic fjord */}
            <g className="contours">
              {Array.from({ length: 14 }).map((_, i) => {
                const y = 80 + i * 26;
                const amp = 18 + i * 2;
                const d = `M -10 ${y} Q 80 ${y - amp} 160 ${y} T 320 ${y} T 410 ${y - amp / 2}`;
                return (
                  <path
                    key={i}
                    d={d}
                    stroke="rgba(245, 241, 234, 0.10)"
                    strokeWidth="1"
                    fill="none"
                  />
                );
              })}
            </g>
            {/* A bold market line through the contours — draws itself in on load */}
            <path
              className="market-line"
              d="M 20 360 L 70 320 L 110 340 L 160 270 L 210 290 L 260 220 L 310 240 L 370 160"
              stroke="url(#line-gradient)"
              strokeWidth="2.5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {/* End point dot — fades in when the line lands, then pulses */}
            <g className="market-endpoint">
              <circle cx="370" cy="160" r="5" fill="#E8B65A" />
              <circle cx="370" cy="160" r="11" fill="#E8B65A" fillOpacity="0.18" />
            </g>
          </svg>
          <div className="badge">
            <div>
              <h3>Nordic Equities</h3>
              <div className="sub">Aggregated portfolio · YTD</div>
            </div>
            <div className="ticker">+12.4%</div>
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <span>© Andersen Wealth Management — demo environment</span>
        <span>Built on Quantfolio Platform</span>
      </footer>
    </div>
  );
}
